import classNames from 'classnames/bind';
import { i18nKeys, useTranslation } from 'locales';
import { isDefined } from 'remeda';
import type { RecoveryPlanV2 } from 'shared/hooks/use-load-company-configuration';
import { Button } from 'shared/io';

import styleIdentifiers from './ChooseRecoveryPlanModal.module.scss';

const styles = classNames.bind(styleIdentifiers);

type Props = {
  className?: string;
  onClick: (planId: RecoveryPlanV2['id'] | null) => void;
  recoverPlans: Array<{ id?: number | string; name: string }>;
};

export default function ChooseRecoveryPlanModal({ className, recoverPlans, onClick }: Props) {
  const { t } = useTranslation();
  const click = (planId: string | number | undefined) => () => {
    if (!isDefined(planId)) return;
    onClick(String(planId));
  };

  return (
    <div className={styles('choose-recovery-plan-modal', className)}>
      {recoverPlans.map(plan => (
        <div className={styles('plan')} key={plan.id}>
          {plan.name}
          <Button label={t(i18nKeys.CHOOSE)} noMargin onClick={click(plan.id)} />
        </div>
      ))}
    </div>
  );
}
